var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOdometerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 2.75C11.3797 2.75 11.6875 3.0578 11.6875 3.4375V5.5C11.6875 5.8797 11.3797 6.1875 11 6.1875C10.6203 6.1875 10.3125 5.8797 10.3125 5.5V3.4375C10.3125 3.0578 10.6203 2.75 11 2.75Z",
    fill: "#005182"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13182 5.13182C5.40031 4.86333 5.83561 4.86333 6.10409 5.13182L7.36114 6.38886C7.62962 6.65735 7.62962 7.09265 7.36114 7.36114C7.09265 7.62962 6.65735 7.62962 6.38886 7.36114L5.13182 6.10409C4.86334 5.83561 4.86334 5.4003 5.13182 5.13182Z",
    fill: "#005182"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 11C2.75 10.6203 3.0578 10.3125 3.4375 10.3125H5.61796C5.99765 10.3125 6.30546 10.6203 6.30546 11C6.30546 11.3797 5.99765 11.6875 5.61796 11.6875H3.4375C3.0578 11.6875 2.75 11.3797 2.75 11Z",
    fill: "#005182"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 11C15.8125 10.6203 16.1203 10.3125 16.5 10.3125L18.5625 10.3125C18.9422 10.3125 19.25 10.6203 19.25 11C19.25 11.3797 18.9422 11.6875 18.5625 11.6875H16.5C16.1203 11.6875 15.8125 11.3797 15.8125 11Z",
    fill: "#005182"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8497 5.16206C16.6524 4.96476 16.3365 4.9525 16.1245 5.13392L10.3775 10.052C9.82365 10.526 9.79085 11.3712 10.3063 11.8867C10.8336 12.414 11.7023 12.3656 12.1678 11.783L16.8893 5.87335C17.0592 5.66076 17.0421 5.35447 16.8497 5.16206Z",
    fill: "#005182"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16266 21.8472C3.96216 20.9728 0 16.4491 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 13.0851 21.4199 15.0346 20.4122 16.6961C18.484 19.8755 14.9901 22 11.0001 22C10.374 22 9.76014 21.9477 9.16266 21.8472ZM2.74866 15.9582C5.17591 14.5538 7.99411 13.75 11.0001 13.75C14.006 13.75 16.8241 14.5538 19.2514 15.9582C20.1234 14.51 20.625 12.8136 20.625 11C20.625 5.68426 16.3157 1.375 11 1.375C5.68426 1.375 1.375 5.68426 1.375 11C1.375 12.8136 1.87661 14.5101 2.74866 15.9582Z",
    fill: "#005182"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdometerIcon);
export default __webpack_public_path__ + "static/media/odometerIcon.68777d7a344d650bcef9770b8cc7fe3b.svg";
export { ForwardRef as ReactComponent };